import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { RESEND_VERIFICATION_LINK, RESEND_VERIFICATION_LINK_SUCCESS, RESEND_VERIFICATION_LINK_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* ResendVerificationLink({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { clientId, programId, userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/clients/${clientId}/programs/${programId}/user/${userId}/resend-verification-link`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: RESEND_VERIFICATION_LINK_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: RESEND_VERIFICATION_LINK_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: RESEND_VERIFICATION_LINK_ERROR, payload: error });
  }
}

export function* watchResendVerificationLink() {
  yield takeEvery(RESEND_VERIFICATION_LINK, ResendVerificationLink);
}

function* ResendVerificationLinkSaga() {
  yield all([fork(watchResendVerificationLink)]);
}

export default ResendVerificationLinkSaga;
